import { render, staticRenderFns } from "./exchangeListArea.vue?vue&type=template&id=35d5f0bd&scoped=true&"
import script from "./exchangeListArea.vue?vue&type=script&lang=js&"
export * from "./exchangeListArea.vue?vue&type=script&lang=js&"
import style0 from "./exchangeListArea.vue?vue&type=style&index=0&id=35d5f0bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5f0bd",
  null
  
)

export default component.exports